export default {
  navBar: {
    phone: '电话: 400-852-6298',
    chinese: '中文版',
    english: 'English',
    brandName: '利未涉外',
    brandSubtitle: 'LEGAL & BUSINESS SERVICES',
    home: '首页',
    businessServices: '商务服务',
    legalServices: '法务服务',
    knowledge: '相关知识',
    about: '关于我们',
    contact: '联系我们',
  },
  hero: {
    tagline: '专注跨境全链路服务，整合法律、金融与商务，护航企业出海',
    consultNow: '立即咨询',
    learnMore: '了解更多',
  },
  stats: {
    '0': {
      title: '20年+经验',
      description: '深耕跨境服务领域20余年，服务超过100+家企业',
    },
    '1': {
      title: '全球网络',
      description: '覆盖50+国家和地区的服务网络',
    },
    '2': {
      title: '专业可靠',
      description: '专业法律、财税、商务团队，确保服务质量',
    },
    '3': {
      title: '一站式服务',
      description: '从公司注册到运营管理的全流程服务',
    },
  },
  sideBar: {
    phone: '联系电话',
    email: '邮件咨询',
    wechat: '微信咨询',
    wechatScan: '微信扫码咨询',
  },
  footer: {
    address: '浙江省杭州市拱墅区中山北路 611 号地铁商务大厦11楼1101 室',
    coreServices: '核心服务',
    copyright: '© 2026 利未涉外 版权所有',
    friendlyLinks: '友情链接',
    hkRegistration: '香港公司注册',
    offshoreRegistration: '离岸公司注册',
    odiInvestment: 'ODI境外投资备案',
    vieStructure: 'VIE架构搭建',
    companyRegistration: '公司注册和管理',
    banking: '银行账户',
    accounting: '会计审计',
    companySearch: '公司查册',
    crossBorderInvestment: '跨境投资',
    taxPlanning: '国际税务计划',
    internationalSolutions: '国际商业解决方案',
    legalOpinion: '法律查明',
    legalOpinionFull: '法律查明及法律意见书',
    notarization: '境外公证认证',
    notarizationFull: '境外公证和认证',
    dueDiligence: '尽职调查',
    contractDrafting: '合同起草审阅',
    contractDraftingFull: '境外商业合同起草审阅',
    propertyInvestigation: '产权调查',
    arbitrationEnforcement: '仲裁裁决执行',
    arbitrationEnforcementFull: '仲裁裁决境外执行',
    generalLegal: '一般性法律服务',
    // 友情链接
    friendlyLink1: '中国投资指南（商务部）',
    friendlyLink2: '中国国际贸易促进委员会',
    friendlyLink3: '国家外汇管理局',
    friendlyLink4: 'LinkedIn',
    friendlyLink5: '世界知识产权组织',
    friendlyLink6: '美国专利商标局',
  },
}
